import React from 'react'
import Accordions from '../../components/Accordions';
const FaqItems = ({data}) => {
  return (
    <Accordions data={data} />
  )
}

export default FaqItems